import { render, staticRenderFns } from "./odiv-zzszyfp.vue?vue&type=template&id=b9e00ec4&scoped=true&"
import script from "./odiv-zzszyfp.vue?vue&type=script&lang=js&"
export * from "./odiv-zzszyfp.vue?vue&type=script&lang=js&"
import style0 from "./odiv-zzszyfp.vue?vue&type=style&index=0&id=b9e00ec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e00ec4",
  null
  
)

export default component.exports